import { useState, useEffect, useCallback, useRef } from 'react';
import { getCompanyEmailGroups } from '../api';

export default function useEmailGroups({ companyId }) {
    const emptyData = { rows: [], total: 0, page: 1, pageSize: 10, totalPages: 0 };
    const [data, setData] = useState(emptyData);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [page, setPage] = useState(1);
    const [pageSize] = useState(10);
    const [search, setSearch] = useState('');
    const fetchIdRef = useRef(0);

    const fetch = useCallback(async () => {
        if (!companyId) return;
        const fetchId = ++fetchIdRef.current;
        setLoading(true);
        setError(null);
        try {
            const params = { page, pageSize, search: search || undefined };
            const res = await getCompanyEmailGroups(companyId, params);
            if (fetchId === fetchIdRef.current) {
                setData(res.data || emptyData);
            }
        } catch (err) {
            if (fetchId === fetchIdRef.current) {
                setError(err.response?.data?.message || err.message || 'Failed to load email groups');
            }
        } finally {
            if (fetchId === fetchIdRef.current) {
                setLoading(false);
            }
        }
    }, [companyId, page, pageSize, search]);

    useEffect(() => { fetch(); }, [fetch]);
    useEffect(() => { setPage(1); }, [companyId, search]);

    const handleSetSearch = useCallback((val) => { setSearch(val); }, []);

    return { data, loading, error, page, setPage, setSearch: handleSetSearch, refetch: fetch };
}
